import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [btnText, setBtnText] = useState("Send Enquiry →");

  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnText("✓ Message Sent!");
    setTimeout(() => setBtnText("Send Enquiry →"), 3500);
  };

  return (
    <section id="contact">
      <div className="section-hero">
        <div className="prlx-bg" style={{ backgroundImage: `url('/assets/images/nx-x-advanced-is2167549305-promo-640x480.jpeg')` }}></div>
        <div className="prlx-overlay"></div>
        <div className="prlx-overlay-gold"></div>
        <div className="sh-content">
          <div className="sh-label">Get in Touch</div>
          <h2 className="sh-title">Contact <em>Profibercom</em></h2>
        </div>
      </div>

      <div className="sec contact-sec">
        <div className="sec-inner">
          <div className="contact-grid">
            <div className="reveal-left">
              <div className="sec-label">Contact Information</div>
              <h2 className="sec-title" style={{ color: '#fff' }}>Let's Work <span style={{ color: 'var(--gold)' }}>Together</span></h2>
              <div className="divider"></div>
              <p style={{ color: 'rgba(255,255,255,.65)', fontSize: '15px', lineHeight: '1.75', marginBottom: '28px' }}>
                Reach out for enquiries, orders, or technical support. Our team is ready to assist with your industrial technology needs.
              </p>
              
              <div className="contact-cards">
                <div className="contact-card">
                  <div className="contact-card-ico">☎️</div>
                  <div><h4>Landline</h4><a href="tel:0158801599">015 880 1599</a></div>
                </div>
                <div className="contact-card">
                  <div className="contact-card-ico">📧</div>
                  <div><h4>General Enquiries</h4><a href="mailto:admin@profibercom.co.za">admin@profibercom.co.za</a></div>
                </div>
                <div className="contact-card">
                  <div className="contact-card-ico">🛒</div>
                  <div><h4>Sales & Orders</h4><a href="mailto:Orders@profibercom.co.za">Orders@profibercom.co.za</a></div>
                </div>
                <div className="contact-card">
                  <div className="contact-card-ico">👤</div>
                  <div><h4>Management</h4><a href="mailto:Manager@profibercom.co.za">Manager@profibercom.co.za</a></div>
                </div>
              </div>
            </div>
            
            <div className="contact-form-wrap reveal-right">
              <h3>Send Us a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="fgrp"><label>First Name</label><input type="text" placeholder="John" required /></div>
                  <div className="fgrp"><label>Last Name</label><input type="text" placeholder="Smith" required /></div>
                </div>
                <div className="fgrp"><label>Email Address</label><input type="email" placeholder="john@company.co.za" required /></div>
                <div className="fgrp"><label>Company</label><input type="text" placeholder="Your Company Name" /></div>
                <div className="fgrp">
                  <label>Enquiry Type</label>
                  <select>
                    <option>Product Enquiry</option>
                    <option>Technical Support</option>
                    <option>Request a Quote</option>
                  </select>
                </div>
                <div className="fgrp"><label>Message</label><textarea placeholder="Tell us about your project or requirements..." required></textarea></div>
                <button type="submit" className="form-submit" style={{ background: btnText.includes('Sent') ? '#27ae60' : '' }}>
                  {btnText}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="map-sec">
        <div className="map-overlay-card">
          <span className="map-tag">Our Location</span>
          <h4>Profibercom (Pty) Ltd</h4>
          <p>Lekgwareng 23 mabocha, Burgersfort<br />1150, Marcia Hlama<br /><br />
            <a href="mailto:admin@profibercom.co.za" style={{ color: 'var(--gold)' }}>admin@profibercom.co.za</a>
          </p>
        </div>
        <div className="map-wrapper">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d457349.8815993867!2d27.89282699999999!3d-26.204103299999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e950c68f0406a51%3A0x238ac9d9b1d34041!2sJohannesburg%2C%20South%20Africa!5e0!3m2!1sen!2s!4v1700000000000!5m2!1sen!2s"
            allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
            title="Profibercom Location">
          </iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;